(function($){
    
    $('.hamburger').click(function() {
        $('.hamburger, .mobile-menu').toggleClass('is-active');
    });

    $('.toggle-share').click(function() {
      $('.share-social').toggleClass('is-active');
    });

    $('.gallery__items').slick({
        //dots: true,
        arrows: true,
        slidesPerRow: 3,
        slidesToScroll: 1,
        infinite: false,
        responsive: [
        {
          breakpoint: 478,
          settings: {
            slidesPerRow: 1,
            rows: 1,
          }
        }
      ]
      });

      jQuery(".slide_next").click(function(){
        jQuery(".slick-next").trigger("click");
        return false;
     });
     jQuery(".slide_prev").click(function(){
        jQuery(".slick-prev").trigger("click");
        return false;
     });

})(jQuery);

